import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const salesloft = defineConnector({
  identifier: "salesloft",
  name: "SalesLoft",
  tagLine: "Revenue orchestration platform",
  keywords:
    "revenue orchestration engagement cadences people accounts sdr prospecting",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://api\\.salesloft\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [SalesLoft](https://www.salesloft.com/) account. Go to **Your Applications → API Keys** and click **Create New**. Enter a name, select the scopes you need, and save.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "SalesLoft API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.salesloft.com/v2/me.json",
  },
});
